import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const OfferFitUseCaseDetails = lazy(() =>
  import("@scenes/OfferFit/components/OfferFitUseCaseDetails").then((module) => ({
    default: module.OfferFitUseCaseDetails,
  }))
);

export const offerfitUseCaseDetailsNRO: NavigationRoutingObject = {
  Component: OfferFitUseCaseDetails,
  componentFeatureFlippers: ["offerfit_dashboard"],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("offerfit-use-case-details-nro-heading", "BrazeAI Decisioning Studio™ Agent Details"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "offerfit-use-case-details-nro-description",
      "See how your BrazeAI Decisioning Studio™ agents are performing"
    ),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    if (!featureOn("offerfit_dashboard")) {
      return false;
    }

    const userHasViewDecisioningStudioAgentsPermission = hasPermission("appGroup", {
      permission: "viewDecisioningStudioAgents",
    });

    return userHasViewDecisioningStudioAgentsPermission;
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
